(function () {
  'use strict';

  var PROXY_PATH = '/a/search';
  var DEBOUNCE_MS = 250;
  var TIMEOUT_MS = 1500;
  var CACHE_TTL_MS = 30 * 1000;
  var CACHE_MAX = 64;
  var RESULT_MAX = 20;
  var ROW_MAX = 24;
  var timers = new Map();
  var controllers = new Map();
  var pending = new Map();
  var cache = new Map();
  var sequences = new Map();
  var rowId = 0;

  function isProxyPath(pathname) {
    return pathname === PROXY_PATH || pathname === PROXY_PATH + '/';
  }

  function cleanLabel(raw) {
    var label = String(raw == null ? '' : raw).replace(/\s+/g, ' ').trim();
    if (!label || label.length > 100 || /[\u0000-\u001f\u007f<>{}%]/.test(label)) return '';
    return label;
  }

  function normalizedText(raw) {
    return String(raw == null ? '' : raw)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function setStatus(root, group, message, busy) {
    var status = root.querySelector('[data-sfs-query-option-status="' + group + '"]');
    var input = root.querySelector('[data-sfs-query-option-search="' + group + '"]');
    if (status) status.textContent = message || '';
    if (input) input.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function currentQuery(root, group) {
    var input = root.querySelector('[data-sfs-query-option-search="' + group + '"]');
    return normalizedText(input ? input.value : '');
  }

  function copyPreviewParams(target, source) {
    ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
      var value = source.searchParams.get(key);
      if (value != null) target.searchParams.set(key, value);
    });
  }

  function requestUrl(group, query) {
    var current = new URL(window.location.href);
    var url = new URL(PROXY_PATH, window.location.origin);
    ['q', 'facets', 'sort', 'sfs_browse', 'sfs_cards', 'sb_brand_label'].forEach(function (key) {
      var value = current.searchParams.get(key);
      if (value != null && value !== '') url.searchParams.set(key, value);
    });
    url.searchParams.set('sfs_endpoint', 'query_options');
    url.searchParams.set('sfs_filters', '1');
    url.searchParams.set('sfs_group', group);
    url.searchParams.set('sfs_query', query.slice(0, 40));
    copyPreviewParams(url, current);
    return url;
  }

  function safeHref(rawHref) {
    try {
      var url = new URL(rawHref, window.location.origin);
      if (
        url.origin !== window.location.origin ||
        !isProxyPath(url.pathname) ||
        url.hash ||
        url.username ||
        url.password ||
        url.searchParams.get('sfs_filters') !== '1' ||
        url.searchParams.has('sb_brand_preview_token')
      ) return '';
      return url.pathname + url.search;
    } catch (error) {
      return '';
    }
  }

  function filterRows(root, group, query) {
    var list = root.querySelector('[data-sfs-query-option-list="' + group + '"]');
    if (!list) return;
    var normalized = normalizedText(query);
    list.querySelectorAll('[data-sfs-query-option-item]').forEach(function (row) {
      var link = row.querySelector('[data-sfs-query-filter-link]');
      var label = link ? normalizedText(link.dataset.sfsQueryOptionLabel) : '';
      row.hidden = !!normalized && label.indexOf(normalized) === -1;
      if (!normalized && row.hasAttribute('data-sfs-query-option-dynamic')) {
        var input = row.querySelector('.filter-input');
        if (!input || !input.checked) row.remove();
      }
    });
    list.querySelectorAll('.brand-filter-section-label').forEach(function (heading) {
      heading.hidden = !!normalized;
    });
  }

  function ensureRow(root, group, option) {
    var list = root.querySelector('[data-sfs-query-option-list="' + group + '"]');
    if (!list) return null;
    var existing = Array.prototype.find.call(
      list.querySelectorAll('[data-sfs-query-filter-link]'),
      function (link) { return link.dataset.sfsQueryOptionLabel === option.label; }
    );
    var row = existing && existing.closest('[data-sfs-query-option-item]');
    if (!row) {
      if (list.querySelectorAll('[data-sfs-query-option-item]').length >= ROW_MAX && !option.active) {
        return null;
      }
      var template = list.querySelector('[data-sfs-query-option-item]');
      if (!template) return null;
      row = template.cloneNode(true);
      row.setAttribute('data-sfs-query-option-dynamic', '');
      row.hidden = false;
      list.appendChild(row);
    }

    var input = row.querySelector('.filter-input');
    var inputLabel = row.querySelector('label[for]');
    var text = row.querySelector('.text');
    var count = row.querySelector('.count');
    var link = row.querySelector('[data-sfs-query-filter-link]');
    if (!link) return null;
    if (!input || !input.id || row.hasAttribute('data-sfs-query-option-dynamic')) {
      rowId += 1;
      var id = 'sfsQueryOption-' + rowId;
      if (input) input.id = id;
      if (inputLabel) inputLabel.setAttribute('for', id);
    }
    if (input) {
      input.checked = option.active;
      input.disabled = true;
      input.value = option.label;
      input.name = 'filter.' + group;
      input.setAttribute('tabindex', '-1');
      input.setAttribute('aria-hidden', 'true');
    }
    if (text) text.textContent = option.label;
    if (count) count.setAttribute('data-count', String(option.count));
    link.dataset.sfsQueryOptionGroup = group;
    link.dataset.sfsQueryOptionLabel = option.label;
    link.href = option.href;
    link.setAttribute('aria-label', (option.active ? 'Remove ' : 'Add ') + option.label);
    if (option.active) link.setAttribute('aria-current', 'true');
    else link.removeAttribute('aria-current');
    return row;
  }

  function applyResults(root, group, options, query) {
    var list = root.querySelector('[data-sfs-query-option-list="' + group + '"]');
    if (!list) return;
    list.querySelectorAll('[data-sfs-query-option-dynamic]').forEach(function (row) {
      var input = row.querySelector('.filter-input');
      if (!input || !input.checked) row.remove();
    });
    options.slice(0, RESULT_MAX).forEach(function (option) {
      ensureRow(root, group, option);
    });
    filterRows(root, group, query);
    setStatus(root, group, options.length ? '' : 'No matching options.', false);
  }

  function readCache(key) {
    var cached = cache.get(key);
    if (!cached) return null;
    if (cached.expiresAt <= Date.now()) {
      cache.delete(key);
      return null;
    }
    cache.delete(key);
    cache.set(key, cached);
    return cached.options;
  }

  function writeCache(key, options) {
    cache.set(key, { options: options, expiresAt: Date.now() + CACHE_TTL_MS });
    while (cache.size > CACHE_MAX) cache.delete(cache.keys().next().value);
  }

  async function loadOptions(root, group, query) {
    if (window.SFSNativeFallback && window.SFSNativeFallback.enabled() && window.SFSNativeFallback.blockOptionSearch()) {
      setStatus(root, group, 'Select a visible filter value.', false);
      return;
    }
    var normalized = normalizedText(query);
    if (normalized.length < 2) return;
    var cacheKey = group + ':' + normalized + ':' + window.location.search;
    var cached = readCache(cacheKey);
    if (cached) {
      applyResults(root, group, cached, query);
      return;
    }
    if (controllers.has(group)) {
      pending.set(group, query);
      return;
    }

    var controller = new AbortController();
    var sequence = (sequences.get(group) || 0) + 1;
    var timedOut = false;
    var timeout = window.setTimeout(function () {
      timedOut = true;
      controller.abort();
    }, TIMEOUT_MS);
    sequences.set(group, sequence);
    controllers.set(group, controller);
    setStatus(root, group, 'Searching filter options...', true);
    try {
      var response = await fetch(requestUrl(group, query).toString(), {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error('query options returned ' + response.status);
      var payload = await response.json();
      if (!payload || payload.group !== group || !Array.isArray(payload.options)) {
        throw new Error('invalid query options response');
      }
      var options = [];
      payload.options.slice(0, RESULT_MAX).forEach(function (item) {
        var label = cleanLabel(item && item.label);
        var optionHref = safeHref(item && item.href);
        if (!label || !optionHref || options.some(function (option) {
          return option.label === label;
        })) return;
        options.push({
          label: label,
          href: optionHref,
          count: Math.max(0, Number(item.count) || 0),
          active: item.active === true
        });
      });
      writeCache(cacheKey, options);
      if (sequences.get(group) === sequence && currentQuery(root, group) === normalized) {
        applyResults(root, group, options, query);
      }
    } catch (error) {
      if (sequences.get(group) === sequence && currentQuery(root, group) === normalized &&
          (timedOut || error.name !== 'AbortError')) {
        setStatus(root, group, 'Filter options are temporarily unavailable.', false);
      }
    } finally {
      window.clearTimeout(timeout);
      if (controllers.get(group) === controller) controllers.delete(group);
      var nextQuery = pending.get(group);
      pending.delete(group);
      if (nextQuery && normalizedText(nextQuery) !== normalized) {
        loadOptions(root, group, nextQuery);
      } else if (currentQuery(root, group).length < 2) {
        setStatus(root, group, '', false);
      }
    }
  }

  function init() {
    var root = document.querySelector('[data-sfs-query-filters="true"]');
    if (!root || root.getAttribute('data-sfs-query-options-ready') === 'true') return;
    root.setAttribute('data-sfs-query-options-ready', 'true');
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sfs-query-option-search-focus]');
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      event.stopPropagation();
      var input = button.parentElement.querySelector('[data-sfs-query-option-search]');
      if (input) input.focus();
    }, true);
    root.addEventListener('input', function (event) {
      var input = event.target.closest('[data-sfs-query-option-search]');
      if (!input || !root.contains(input)) return;
      var group = input.dataset.sfsQueryOptionSearch || '';
      var query = input.value.trim().slice(0, 40);
      filterRows(root, group, query);
      if (timers.has(group)) window.clearTimeout(timers.get(group));
      if (normalizedText(query).length < 2) {
        pending.delete(group);
        setStatus(root, group, '', false);
        return;
      }
      timers.set(group, window.setTimeout(function () {
        loadOptions(root, group, query);
      }, DEBOUNCE_MS));
    });
    window.addEventListener('pagehide', function () {
      controllers.forEach(function (controller) { controller.abort(); });
      controllers.clear();
      pending.clear();
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
